import React from 'react';
import { ListGroup, Badge } from "react-bootstrap";
import PendingActionItemRow from '../../../../partials/content/dxControls/PendingActionItemRow';
import { withRouter } from '../../../../shared/hoc/withRouter';
import { injectIntl } from "react-intl";


class NotifyArea2 extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.actionsObj !== nextProps.actionsObj) {
            return true;
        }
        return false;
    }
    render() {
        return (
            <ListGroup
                key={this.props.skey + "-ListGroup"}
            >
                {
                    this.props.actionsObj.items.map((actionItem, index) => (
                        <ListGroup.Item
                            key={this.props.skey + index}
                            style={{ padding: '0.75rem 0.25rem' }}
                            action
                            variant="secondary">
                            <PendingActionItemRow
                                key={this.props.skey + index + "-INNERROW"}
                                skey={this.props.skey + index + "-INNERROW"}
                                actionItem={actionItem}
                                workflow={this.props.actionsObj.workflow}
                                panelCloseBtnRef={this.props.panelCloseBtnRef}
                                contract={this.props.contract}
                                contractTemplate={this.props.contractTemplate}
                            />
                        </ListGroup.Item>
                    ))
                }
            </ListGroup>
        );
    }
}



export default injectIntl(withRouter(NotifyArea2));